import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoaderService } from 'app/_services/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
    isLoading = false;

    constructor(private loaderService: LoaderService, private cdRef: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.init();
    }

    init() {
        this.loaderService.getLoaderObserveable().subscribe((status) => {
            this.isLoading = status === 'start';
            this.cdRef.detectChanges();
        });
    }
}
